import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vue3GoogleLogin from 'vue3-google-login'

createApp(App).use(router).use(vue3GoogleLogin, {
    clientId: '938050164928-ce31cvgpe1pah15ov85mipnl32mulbr0.apps.googleusercontent.com'
}).mount('#app')
